<template>
  <el-dialog
    :title="$t('affiliateRuleManage.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align: center">
      <p>
        {{ $t('affiliateRuleManage.confirmDelete') }}
        <strong>{{ deleteAffiliateRuleInfo.name }}</strong>？
      </p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('affiliateRuleManage.cancel') }}
      </el-button>
      <el-button type="primary" @click="deleteAffiliateRule" :loading="loading">
        {{ $t('affiliateRuleManage.confirmDeleteBtn') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteAffiliateRule } from '@/api/affiliate/affiliateRuleApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteAffiliateRule',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      deleteAffiliateRuleInfo: {
        ruleId: '',
        name: '',
        shopId: ''
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.deleteAffiliateRuleInfo = {
        ruleId: row.ruleId,
        name: row.name,
        shopId: getShopId()
      }
    },
    handleClose() {
      this.deleteAffiliateRuleInfo = {
        ruleId: '',
        name: '',
        shopId: ''
      }
      this.loading = false
    },
    async deleteAffiliateRule() {
      this.loading = true
      try {
        await deleteAffiliateRule(this.deleteAffiliateRuleInfo)
        this.$message.success(this.$t('affiliateRuleManage.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error(error)
        this.$message.error(error.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>